export const enTrendIdentification = {
  'navbar.menu.analyses.trendIdentification': 'Trend Identification',
  'trendIdentification.title': 'Trend Identification',
  'trendIdentification.fieldPlaceholder': 'Choose value',
  'trendIdentification.sidePanel.title': 'Choose Parameters',
  'trendIdentification.sidePanel.submitedCalculations.title': 'Submitted calculations',
  'trendIdentification.sidePanel.submitedCalculations.label': 'Trend results',
  'trendIdentification.sidePanel.submitedCalculations.placeHolder': 'Chose value',
  'trendIdentification.sidePanel.parameters.title': 'Start new calculation',
  'trendIdentification.sidePanel.parameters.tso.label': 'TSO',
  'trendIdentification.sidePanel.parameters.start.label': 'Start',
  'trendIdentification.sidePanel.parameters.start.supportingText': 'Start date must be a Monday.',
  'trendIdentification.sidePanel.parameters.start.tooltip':
    'To ensure the required period of at least 106 weeks, select the end date first.',
  'trendIdentification.sidePanel.parameters.end.label': 'End',
  'trendIdentification.sidePanel.parameters.end.supportingText': 'End date must be a Sunday.',
  'trendIdentification.sidePanel.parameters.measurmentParameters.label': 'Measurement Parameter',
  'trendIdentification.sidePanel.parameters.measurmentDevice.label': 'Measurement Device',
  'trendIdentification.sidePanel.parameters.reset.label': 'Reset all',
  'trendIdentification.sidePanel.parameters.submit.label': 'Submit calculations',
  'trendIdentification.content.title': 'Trend Identification',
  'trendIdentification.content.description':
    'Identify and visualize trends in measurement parameters across selected time periods.',
  'trendIdentification.deleteDialogue.tooltip': 'Delete trend result',
  'trendIdentification.deleteDialogue.title': 'Delete trend result',
  'trendIdentification.deleteDialogue.contentPart1': 'Are you sure you want to delete “',
  'trendIdentification.deleteDialogue.contentPart2': '”? This action cannot be undone.',
  'trendIdentification.deleteDialogue.buttonLabel': 'Delete',
  'trendIdentification.snackbarDeleteSuccess': 'Calculation was successfully deleted.',
  'trendIdentification.snackbarDeleteError': 'Calculation could not be deleted. Please try again.',
  'trendIdentification.modal.submitCalculation.title': 'Submit calculation',
  'trendIdentification.modal.submitCalculation.description':
    'This trend calculation with the selected parameters can be submitted and saved. The calculations can then be found under “Trend Results”. Once the calculations have been completed, they can then be selected.',
  'trendIdentification.modal.submitCalculation.nameField.label': 'Name for trend calculation',
  'trendIdentification.modal.submitCalculation.nameField.placeholder': 'Enter a name',
  'trendIdentification.modal.submitCalculation.nameField.supportingText':
    'Hint: Allowed characters are a-zA-Z0-9äöüÄÖÜß\s\-_()/.',
  'trendIdentification.dialogTextfieldValidationError':
    'Invalid characters detected. Please remove unsupported symbols.',
  'trendIdentification.dialogTextfieldValidationInvalidName': 'Please enter a valid name.',
  'trendIdentification.modal.submitCalculation.cancel': 'Cancel',
  'trendIdentification.modal.submitCalculation.submit': 'Submit calculation',
  'trendIdentification.placeholder.title': 'No parameters selected.',
  'trendIdentification.placeholder.description': 'Choose trend result to visualize data.',
  'trendIdentification.chart.title': 'Chart of Selected Trends',
  'trendIdentification.chart.subTitle': 'Select a trend in the table above to display its chart here.',
  'trendIdentification.chart.segment1': 'Measurement Device',
  'trendIdentification.chart.segment2': 'Measurement Parameter',
  'trendIdentification.chart.lineColor': 'Line color by:',
  'trendIdentification.chart.noSelection': 'No selection',
  'trendIdentification.chart.measurementDevice': 'Measurement Device',
  'trendIdentification.chart.nominalVoltage': 'Nominal Voltage',
  'trendIdentification.chart.date': 'Date: ',
  'trednIdentification.tableContainer.title': 'Trends',
  'trednIdentification.tableContainer.description':
    'Only entries with data are shown in the table. Up to 6 entries can be selected for visualizaton.',
  'trednIdentification.tableContainer.parameterConfiguration.title': 'Configuration parameters',
  'trednIdentification.tableContainer.parameterConfiguration.placeholder': 'Enter value',
  'trednIdentification.tableContainer.parameterConfiguration.averageIncreasePerYear.label':
    'Average Increase per year >',
  'trednIdentification.tableContainer.parameterConfiguration.averageIncreasePerYear.error':
    'Only numeric values are allowed',
  'trednIdentification.tableContainer.parameterConfiguration.absoluteIncrease.label': 'Absolute Increase >',
  'trednIdentification.tableContainer.parameterConfiguration.absoluteIncrease.error': 'Only numeric values are allowed',
  'trednIdentification.tableContainer.parameterConfiguration.currentValue.label': 'Current Value >',
  'trednIdentification.tableContainer.parameterConfiguration.currentValue.error': 'Only numeric values are allowed',
  'trednIdentification.tableContainer.parameterConfiguration.durationOfIncreaseInWeeks.label':
    'Duration of Increase in weeks >',
  'trednIdentification.tableContainer.parameterConfiguration.durationOfIncreaseInWeeks.error':
    'Only numeric values are allowed',
  'trednIdentification.tableContainer.parameterConfiguration.apply': 'Apply',
  'trednIdentification.tableContainer.noTrendFound.title': 'No trends identified.',
  'trednIdentification.tableContainer.noTrendFound.decription1':
    'For the selected parameters no trends were identified. You can delete this trend calculation ',
  'trednIdentification.tableContainer.noTrendFound.decription2':
    'or adjust the parameters and submit a new calculation.',
  'trednIdentification.maximumNumberOfCells.error': 'The maximum number of selected options is 6.',
  '10minutes.current.currents': 'I_RMS',
  '10minutes.current.harmonics.order01': 'I_H01',
  '10minutes.current.harmonics.order02': 'I_H02',
  '10minutes.current.harmonics.order03': 'I_H03',
  '10minutes.current.harmonics.order04': 'I_H04',
  '10minutes.current.harmonics.order05': 'I_H05',
  '10minutes.current.harmonics.order06': 'I_H06',
  '10minutes.current.harmonics.order07': 'I_H07',
  '10minutes.current.harmonics.order08': 'I_H08',
  '10minutes.current.harmonics.order09': 'I_H09',
  '10minutes.current.harmonics.order10': 'I_H10',
  '10minutes.current.harmonics.order11': 'I_H11',
  '10minutes.current.harmonics.order12': 'I_H12',
  '10minutes.current.harmonics.order13': 'I_H13',
  '10minutes.current.harmonics.order14': 'I_H14',
  '10minutes.current.harmonics.order15': 'I_H15',
  '10minutes.current.harmonics.order16': 'I_H16',
  '10minutes.current.harmonics.order17': 'I_H17',
  '10minutes.current.harmonics.order18': 'I_H18',
  '10minutes.current.harmonics.order19': 'I_H19',
  '10minutes.current.harmonics.order20': 'I_H20',
  '10minutes.current.harmonics.order21': 'I_H21',
  '10minutes.current.harmonics.order22': 'I_H22',
  '10minutes.current.harmonics.order23': 'I_H23',
  '10minutes.current.harmonics.order24': 'I_H24',
  '10minutes.current.harmonics.order25': 'I_H25',
  '10minutes.current.thd': 'I_THD',
  '10minutes.current.unbalance': 'I_UNB',
  '10minutes.voltage.harmonics.even.order02': 'U_H02',
  '10minutes.voltage.harmonics.even.order04': 'U_H04',
  '10minutes.voltage.harmonics.even.order06': 'U_H06',
  '10minutes.voltage.harmonics.even.order08': 'U_H08',
  '10minutes.voltage.harmonics.even.order10': 'U_H10',
  '10minutes.voltage.harmonics.even.order12': 'U_H12',
  '10minutes.voltage.harmonics.even.order14': 'U_H14',
  '10minutes.voltage.harmonics.even.order16': 'U_H16',
  '10minutes.voltage.harmonics.even.order18': 'U_H18',
  '10minutes.voltage.harmonics.even.order20': 'U_H20',
  '10minutes.voltage.harmonics.even.order22': 'U_H22',
  '10minutes.voltage.harmonics.even.order24': 'U_H24',
  '10minutes.voltage.harmonics.odd.order03': 'U_H03',
  '10minutes.voltage.harmonics.odd.order05': 'U_H05',
  '10minutes.voltage.harmonics.odd.order07': 'U_H07',
  '10minutes.voltage.harmonics.odd.order09': 'U_H09',
  '10minutes.voltage.harmonics.odd.order11': 'U_H11',
  '10minutes.voltage.harmonics.odd.order13': 'U_H13',
  '10minutes.voltage.harmonics.odd.order15': 'U_H15',
  '10minutes.voltage.harmonics.odd.order17': 'U_H17',
  '10minutes.voltage.harmonics.odd.order19': 'U_H19',
  '10minutes.voltage.harmonics.odd.order21': 'U_H21',
  '10minutes.voltage.harmonics.odd.order23': 'U_H23',
  '10minutes.voltage.harmonics.odd.order25': 'U_H25',
  '10minutes.voltage.pst': 'U_PST',
  '10minutes.voltage.thd': 'U_THD',
  '10minutes.voltage.unbalance': 'U_UNB',
  '10minutes.voltage.voltagerms': 'U_RMS',
  '2hours.plt': 'U_PLT',
  'trendIdentification.filter.noData.title': 'No results found.',
  'trendIdentification.filter.noData.description':
    'No results match the current configuration parameters. Please adjust the parameters above.',
  'trendIdentification.modal.submitCalculation.submit.success':
    'Calculation was successfully submitted and is now being processed.',
  'trendIdentification.modal.submitCalculation.submit.error': 'Calculation could not be submitted. Please try again.',
  'trendIdentification.chart.placeholder.title': 'No entry selected.',
  'trendIdentification.chart.placeholder.description':
    'Choose an entry from the table above to visualize the trend as a chart.',
};
